import type { ReadonlyDeep } from 'type-fest';

import { CostUsageInput, QuantityInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import type { CostUsageForm_CostUsage } from '../fragments/cost-usage.fragment.tsx';

export function costUsageForm2ApiMapper(
  costUsage: ReadonlyDeep<CostUsageForm_CostUsage>,
): ReadonlyDeep<CostUsageInput> {
  const costUsageInput = pruneInput(costUsage, CostUsageInput);

  return {
    ...costUsageInput,
    quantity: pruneInput(costUsageInput.quantity, QuantityInput),
  };
}
